<template>
  <div class="i-processing">
    <iBackground />

    <iNavbarSimple />

    <template v-if="data.userValidated">
      <div class="container-success">
        <iQuizCompletion
          :user-name="data.userName"
          :user-zip-code="data.userZipCode"
          @animation-completed="onAnimationCompleted"
        />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive } from "vue"
import { useRoute } from "vue-router"

import scrollToTop from "@/composables/scrollToTop"
import { useExitModal } from "@/composables/useExitModal"

import { GlobalVariables } from "@/helpers/globalVariables"

import iBackground from "@/components/global/Background.vue"
import iNavbarSimple from "@/components/global/NavbarSimple.vue"
import { GlobalFunctions } from "@/helpers/globalFunctions"
import iQuizCompletion from "@/views/loading/sections/QuizCompletion.vue"

// COMPOSABLES
const { removeExitModal } = useExitModal()

// ROUTE
const activeRoute = useRoute()

// DATA
const data = reactive({
  userName: "",
  userZipCode: "",
  userValidated: false
})

// FUNCTIONS

function setPageData() {
  const userName = activeRoute.query[GlobalVariables.urlQueryKeys.fullName] || ""
  const userZipCode = activeRoute.query[GlobalVariables.urlQueryKeys.zipCode] || ""

  data.userName = userName as string
  data.userZipCode = userZipCode as string
  data.userValidated = true
}

async function onAnimationCompleted() {
  removeExitModal()
  const baseUrl = `${window.location.protocol}//${window.location.host}`
  const pageUrl = GlobalVariables.urls.start.path
  GlobalFunctions.redirectToPage({ baseUrl, pageUrl })
}

// LIFECYCLE HOOKS

onMounted(() => {
  scrollToTop("instant")
  setPageData()
})
</script>

<style scoped lang="scss">
.i-processing {
  .container-success {
    height: calc(100vh - 90px);
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
    max-width: $section-max-width;
    width: 90%;
  }
}
</style>
